import { BaseService } from 'core/services';
import TeamsRouteService from './TeamsRouteService';

class TeamsService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new TeamsRouteService());
    }

    createTeamUser(resource) {
        const url = this.routeService.createTeamUser(resource);
        return this.apiClient.post(url, resource);
    }

    deleteTeamUser(resource) {
        const url = this.routeService.deleteTeamUser(resource);
        return this.apiClient.delete(url, resource);
    }

    deleteTeamUsers(resource) {
        const url = this.routeService.deleteTeamUsers(resource);
        return this.apiClient.delete(url, resource);
    }
}

export default TeamsService;
